import { render, staticRenderFns } from "./cardV2.vue?vue&type=template&id=7342c7fb&scoped=true"
import script from "./cardV2.vue?vue&type=script&lang=js"
export * from "./cardV2.vue?vue&type=script&lang=js"
import style0 from "./cardV2.vue?vue&type=style&index=0&id=7342c7fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7342c7fb",
  null
  
)

export default component.exports